import React, { useState } from 'react';
import { Grid, InputLabel, MenuItem } from '@mui/material';
import { PrimaryOutlinedButton, PrimaryLightInput, PrimaryLightSelect } from '../../theme/index'
import '../../sass/styles.scss';
import FormControl from '@mui/material/FormControl';
import { useDispatch } from 'react-redux';
import { modalAction } from '../../redux/reducers/Modal';
import { editUserAction } from '../../redux/reducers/Edit';

const UserEdit = (props) => {

    const dispatch = useDispatch();
    const [id, setId] = useState(props.user.id);
    const [role, setRole] = useState(props.user.role);
    const [email, setEmail] = useState(props.user.email);
    const [name, setName] = useState(props.user.name);
    const [lastname, setLastname] = useState(props.user.lastname);
    const [status, setStatus] = useState(props.user.status);

    const editUser = () => {
        const user = new FormData(),
              dataNames = ["id", "name", "lastname", "email", "role", "status"];

        user.append(dataNames[0], id);
        user.append(dataNames[1], name);
        user.append(dataNames[2], lastname);
        user.append(dataNames[3], email);
        user.append(dataNames[4], role);
        user.append(dataNames[5], status);
        user.append('METHOD', 'PUT');

        dispatch(editUserAction(user, dataNames, id));
        dispatch(modalAction());
    }

  return (
    <>
        <Grid item xs={ 10 }>
            <h5 style={{ margin: '0' }}>Usuario / editar</h5>
        </Grid>
        <Grid item xs={ 12 }>
            <Grid container sx={{ py: 6 }}>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Role</InputLabel>
                        <PrimaryLightSelect 
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={ role }
                        onChange={ e => setRole(e.target.value) }
                        >
                            <MenuItem value='admin'>Admin</MenuItem>
                            <MenuItem value='receptionist'>Recepcionista</MenuItem>
                        </PrimaryLightSelect>
                    </FormControl>
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="E-mail"
                        fullWidth
                        value={ email }
                        onChange={ e => setEmail(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Nombre"
                        fullWidth
                        value={ name }
                        onChange={ e => setName(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Apellido"
                        fullWidth
                        value={ lastname }
                        onChange={ e => setLastname(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <PrimaryLightSelect 
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={ status }
                        onChange={ e => setStatus(e.target.value) }
                        >
                            <MenuItem value={true}>Activo</MenuItem>
                            <MenuItem value={false}>Inactivo</MenuItem>
                        </PrimaryLightSelect>
                    </FormControl>
                </Grid>
                <Grid item xs={ 12 } sx={{ mt: 5 }} textAlign='end' className='pr-2'>
                    <PrimaryOutlinedButton onClick={ () => editUser() }>Guardar</PrimaryOutlinedButton>
                </Grid>
            </Grid>
        </Grid>
    </>
  )
}

export default UserEdit